import axios from '@/utils/axios';

export interface CreatePartnershipAdParams {
  brandId: string;
  swapMatchId: string;
  budget: {
    type: 'daily' | 'lifetime';
    amount: number;
  };
  schedule: {
    startDate: Date;
    endDate?: Date;
  };
  audience: {
    ageMin: number;
    ageMax: number;
    genders: string[];
    locations?: string[];
  };
}

export interface CreatePartnershipAdResponse {
  creative_id: string;
  campaign_id: string;
  adset_id: string;
  ad_id: string;
}

const partnershipAdsUpdaters = {
  createPartnershipAd: async (params: CreatePartnershipAdParams) =>
    axios.post<CreatePartnershipAdResponse>(
      '/brand_instagram_business_account/create_partnership_ad',
      {
        brand_id: params.brandId,
        swap_match_id: params.swapMatchId,
        budget_type: params.budget.type,
        budget_amount: params.budget.amount,
        start_date: params.schedule.startDate.toISOString(),
        end_date: params.schedule.endDate?.toISOString(),
        age_min: params.audience.ageMin,
        age_max: params.audience.ageMax,
        genders: params.audience.genders,
        locations: params.audience.locations,
      }
    ),
};

export default partnershipAdsUpdaters;
